import { useNavigate, useLocation } from "react-router-dom";

const useFooter = (options, setOptions) => {
  const { backRoute } = options;

  const navigate = useNavigate();
  const { state } = useLocation();
  const rotas = JSON.parse(sessionStorage.getItem('rotas')) || [];

  const handleBack = () => {
    const params = new URLSearchParams(window.location.search);
    const origem = params.get("origem");

    if (["mapeamento", "acompanhamento-mapeamento"].includes(origem)) {
      const match = window.location.pathname.match(/\/funil-de-obras\/([^/]+)\//);

      if (match) {
        navigate(
          `/funil-de-obras/${match[1]}/${origem}?${params.toString()}`,
          origem === "acompanhamento-mapeamento" && state?.groupSaved === true
            ? { state: { groupSaved: true } }
            : undefined
        );
        return;
      }
    }

    if (backRoute) {
      navigate(backRoute);
    } else {
      const currentDomain = window.location.hostname;
      const previousDomain = document.referrer ? new URL(document.referrer).hostname : null;

      if (previousDomain && currentDomain && previousDomain !== currentDomain) {
        navigate("/");
      } else {
        console.log(rotas, `fds`)

        const currentPath = window.location.pathname;
        const isPesquisaDePreco = currentPath.includes('/pesquisa-de-preco/');

        if (!isPesquisaDePreco) {
          console.log(`Voltando normalmente, rotas: ${rotas}`);

          if (rotas.length > 0 && rotas[rotas.length - 1] === currentPath) {
            rotas.pop();
            sessionStorage.setItem('rotas', JSON.stringify(rotas));
          }
          if (rotas.length > 0) {
            const rotaAnterior = rotas[rotas.length - 1];
            navigate(rotaAnterior);
          } else {
            navigate("/");
          }
          return;
        }
        if (rotas.length < 3) {
          window.history.go(-1);
          return;
        }

        const ultimasRotas = rotas.slice(-3);
        const regexBase = /^\/pesquisa-de-preco\/(\d+)$/;
        const regexEditar = /^\/pesquisa-de-preco\/(\d+)\/editar\/(\d+)$/;

        const isSequenciaNovaPesquisa = (
          ultimasRotas[0]?.match(regexBase) &&
          ultimasRotas[1] === `${ultimasRotas[0]}/nova-pesquisa` &&
          ultimasRotas[2] === ultimasRotas[0]
        );

        const isSequenciaEditar = (
          ultimasRotas[0]?.match(regexBase) &&
          ultimasRotas[1]?.match(regexEditar) &&
          ultimasRotas[2] === ultimasRotas[0]
        );

        if (isSequenciaNovaPesquisa || isSequenciaEditar) {
          console.log(`Sequência exata: ${isSequenciaNovaPesquisa ? 'nova-pesquisa' : 'editar'}`);
        }

        const goBack = isSequenciaNovaPesquisa || isSequenciaEditar ? -3 : -1;
        window.history.go(goBack);
      }
    }
  };

  return { handleBack };
};

export default useFooter;